<template>
  <div class="page_bg">
    <div class="bg_top_linear-gradient">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-r-sb-c">
        <van-icon name="arrow-left" @click="backPath" />
        <div class="top_name">个人信息</div>
        <div class="top_icon" />
      </div>
      <!-- 用户信息 -->
      <div class="user_info_del">
        <van-form @submit="onSubmit">
          <van-field v-model="info.name" label="姓     名" placeholder="宠商首选用户" />
          <van-field value="分销商城" readonly label="行业分类" placeholder="分销商城用户" />
          <van-field v-model="info.mobile" readonly label="手机号" placeholder="手机号" />
          <van-field v-model="info.companyName" label="公司名称" placeholder="公司名称" />
          <van-field v-model="info.companyPosition" label="职      位" placeholder="职      位" />
          <van-field v-model="info.districtName" readonly label="所属地区" />
          <!-- <van-field v-model="info.districtName" readonly clickable label="所属地区" placeholder="请选择所在地区"
                     right-icon="arrow" @click="showPicker = true"
          /> -->
          <div class="sub_btn">
            <van-button round block type="info" native-type="submit" color="#0767AB">保存信息</van-button>
          </div>
        </van-form>
      </div>
    </div>
    <!-- 省市区部分 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-cascader v-model="cascadervalue" title="请选择所在地区" :options="columns" :field-names="fieldNames"
                    @close="closePick" @finish="finishPick"
      />
    </van-popup>
  </div>
</template>

<script>
import './index.scss'
import { districts } from '@/api/public'
import { user_userInfo, user_update } from '@/api/user'
export default {
  name: 'MyInfo',
  data() {
    return {
      info: {},
      // 省市区
      showPicker: false,
      cascadervalue: [],
      columns: [],
      fieldNames: {
        text: 'label',
        value: 'value',
        children: 'children'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    // this.loadDistrict()
    this.getInfo()
  },
  methods: {
    backPath() { window.history.back() },
    getInfo() {
      user_userInfo().then(res => {
        this.info = res.data
        this.cascadervalue = [res.data.provinceId, res.data.cityId, res.data.areaId]
        this.info.districtName = res.data.provinceName + '-' + res.data.cityName + '-' + res.data.areaName
      })
    },
    onSubmit(values) {
      console.log('submit', values)
      user_update(this.info).then(res => {
        this.$toast({ message: '修改成功！', duration: 3 * 1000 })
        window.history.back()
      })
    },
    // 省市区
    // 加载省市区
    loadDistrict() { districts().then(res => { this.columns = res.data }) },
    // 选择结束
    finishPick(value) {
      console.log(value)
      this.showPicker = false
      this.info.districtName = value.selectedOptions[0].label + '-' + value.selectedOptions[1].label + '-' + value.selectedOptions[2].label
      this.info.provinceId = value.selectedOptions[0].value
      this.info.cityId = value.selectedOptions[1].value
      this.info.areaId = value.selectedOptions[2].value
    },
    // 关闭选择
    closePick() {
      this.showPicker = false
    }
  }
}
</script>

<style>
</style>
